/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S5_I2_LabelInputs */

const tr_kullanim_s5_i2_label = /** @type {(inputs: Kullanim_S5_I2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüketici nitelikli taraflar için:`)
};

const en_kullanim_s5_i2_label = /** @type {(inputs: Kullanim_S5_I2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For parties qualifying as consumers:`)
};

const de_kullanim_s5_i2_label = /** @type {(inputs: Kullanim_S5_I2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für Parteien mit Verbrauchereigenschaft:`)
};

const ru_kullanim_s5_i2_label = /** @type {(inputs: Kullanim_S5_I2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для сторон со статусом потребителя:`)
};

/**
* | output |
* | --- |
* | "For parties qualifying as consumers:" |
*
* @param {Kullanim_S5_I2_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s5_i2_label = /** @type {((inputs?: Kullanim_S5_I2_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S5_I2_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s5_i2_label(inputs)
	if (locale === "de") return de_kullanim_s5_i2_label(inputs)
	if (locale === "ru") return ru_kullanim_s5_i2_label(inputs)
	return tr_kullanim_s5_i2_label(inputs)
});